import $ from "jquery";

$(function () {
  $("body").removeClass("is-loading");
});
